import {
  LabelsTab,
  MultiLabelFormattingProps,
} from '@ardoq/perspectives-sidebar';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { connect } from '@ardoq/rxbeach';
import { labelsTab$ } from 'perspectiveSidebar/perspectiveEditor/labelsTab$';
import { ViewOptionsPerspectivesPage as ViewOptionsPerspectivesPageBase } from './ViewOptionsPerspectivesPage';
import { KnowledgeBaseLink } from '@ardoq/knowledge-base';
import { t, type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';

type ViewOptionsPerspectivesLabelsProps = MultiLabelFormattingProps & {
  onClickOutside?: VoidFunction;
  i18nLocale: I18nLocale;
};

const ViewOptionsPerspectivesLabelsBase = ({
  onClickOutside,
  i18nLocale,
  ...props
}: ViewOptionsPerspectivesLabelsProps) => (
  <ViewOptionsPerspectivesPageBase
    title={t(i18nLocale, 'appLayout:labelsPageTitle', 'Labels')}
    knowledgeBaseLink={KnowledgeBaseLink.LABEL_FORMATTING}
    onClickOutside={onClickOutside}
  >
    <LabelsTab {...props} />
  </ViewOptionsPerspectivesPageBase>
);

export const ViewOptionsPerspectivesLabels = connect(
  ViewOptionsPerspectivesLabelsBase,
  combineLatest([labelsTab$, i18nLocale$]).pipe(
    map(([props, i18nLocale]) => ({ ...props, i18nLocale }))
  )
);
